export const body = {};

export const counterStyle = {
    textAlign: "right",
    color: "red"
};

export const errorHide = {
    visibility: "hidden",
    color: "red"
};

export const errorShow = {
    visibility: "visible",
    color: "red"
};

export const deposit = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "10px"
};

export const depositPrice = {
    display: "flex",
    justifyContent: "right",
    alignItems: "center"
};

export const percentageError = {
    color: "red"
};
